import React from 'react'

const PROGRAM_DIGITAL_WELL_BEING = 'digital well-being unit'

// Contentful internal titles are authored freehand, so normalize the same way the
// dashboard's DWB predicate does in pages/Dashboard/helpers.js
export const isDigitalWellBeingProgram = program =>
  String(program || '')
    .toLowerCase()
    .trim() === PROGRAM_DIGITAL_WELL_BEING

export function superscriptRegistered(title) {
  if (title.includes('®')) {
    const parts = title.split('®')
    return (
      <>
        {parts[0]}
        <sup>®</sup> {parts[1].trim()}
      </>
    )
  }
  return title
}

export const getBackgroundColor = ({
  isHighSchoolFamily,
  isMindYetiProduct,
  isOstProduct,
  isSelaProduct,
  program,
  themeGet,
}) => {
  // TODO: drop this in favour of colors.themePrimary once the DWB theme exists
  // and is mapped in themeMap
  const isDigitalWellBeingProduct = isDigitalWellBeingProgram(program)

  const productColors = {
    isDigitalWellBeingProduct: themeGet('colors.dwbBlueHover'),
    isOstProduct: themeGet('colors.programCard.background.color'),
    isMindYetiProduct: themeGet('colors.lightBlue'),
    isHighSchoolFamily: themeGet('colors.highschool.themePrimary'),
    isSelaProduct: themeGet('colors.themeAccent'),
  }

  if (isDigitalWellBeingProduct) {
    return productColors.isDigitalWellBeingProduct
  }
  if (isOstProduct) {
    return productColors.isOstProduct
  }
  if (isMindYetiProduct) {
    return productColors.isMindYetiProduct
  }
  if (isHighSchoolFamily) {
    return productColors.isHighSchoolFamily
  }
  if (isSelaProduct) {
    return productColors.isSelaProduct
  }

  // Default color if no conditions are met
  return themeGet('colors.themePrimary')
}
